/**
 * usePendingSync — returns the current pending sync count.
 *
 * Desktop (window.pms): reads from the IPC SyncStatus pushed by the SyncWorker.
 * Browser legacy engines (syncEngine, genericSyncEngine) are removed — desktop only.
 */
import { useState, useEffect, useCallback } from 'react';

export function usePendingSync() {
  const [pendingSync, setPendingSync] = useState(0);

  const refreshPending = useCallback(async () => {
    try {
      if (window.pms) {
        const s = await window.pms.getSyncStatus?.().catch(() => null);
        setPendingSync(s?.pending ?? 0);
      }
      // Browser path with IndexedDB engines is not available in this build.
    } catch (_) {}
  }, []);

  useEffect(() => {
    refreshPending();
    const onDone = () => refreshPending();
    window.addEventListener('hotelmis:sync:done',         onDone);
    window.addEventListener('hotelmis:generic:sync:done', onDone);
    window.addEventListener('hotelmis:data:mutated',      onDone);
    return () => {
      window.removeEventListener('hotelmis:sync:done',         onDone);
      window.removeEventListener('hotelmis:generic:sync:done', onDone);
      window.removeEventListener('hotelmis:data:mutated',      onDone);
    };
  }, [refreshPending]);

  return { pendingSync };
}
